import { createSelector } from "reselect"
import { get } from "lodash"
import { getIsPeriodIntraday } from "./dates"

const EMPTY_ARRAY = []

export function createIntradaySelector(eodPath, intradayPath, eodFallback = EMPTY_ARRAY, intradayFallback = EMPTY_ARRAY) {
  return createSelector(
    [
      state => get(state, eodPath, eodFallback),
      state => get(state, intradayPath, intradayFallback),
      getIsPeriodIntraday,
    ],
    (simData, intradayData, isPeriodIntraday) =>
      isPeriodIntraday ? intradayData : simData,
  )
}
